import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from 'app/service/user.service';
import { marked } from 'marked';

// Öffentliche Datenschutzerklärung (/privacy). Texte: i18n signup.Termsandconditions.*
@Component({
  standalone: false,
  selector: 'app-privacy',
  templateUrl: './privacy.component.html',
  styleUrls: ['./privacy.component.scss']
})
export class PrivacyComponent implements OnInit {
  readonly currentYear = new Date().getFullYear();
  selectedLanguage = 'en';
  // Text aus den versionierten Dokumenten; fehlt er, gelten die Texte der Übersetzungsdateien
  documentHtml = '';
  version = '';

  supportedLanguages: { code: string, name: string }[] = [
    { code: 'de', name: 'Deutsch' },
    { code: 'en', name: 'English' },
    { code: 'fr', name: 'Français' },
    { code: 'pt', name: 'Português' }
  ];

  // Abschnitte in Reihenfolge: [Überschrift-Key, Text-Key]
  readonly sections: string[][] = [
    ['GeneralInformation', 'GeneralInformationtext'],
    ['PurposeofDataCollection', 'PurposeofDataCollectiontext'],
    ['TypesofDataCollected', 'TypesofDataCollectedtext'],
    ['LegalBasisforProcessing', 'LegalBasisforProcessingtext'],
    ['DataUseandSharing', 'DataUseandSharingtext'],
    ['DataStorageandDeletion', 'DataStorageandDeletiontext'],
    ['TechnicalSecurity', 'TechnicalSecuritytext'],
    ['QualityandValidity', 'QualityandValiditytext'],
    ['YourRights', 'YourRightstext'],
    ['WithdrawalofConsent', 'WithdrawalofConsenttext'],
    ['RighttoComplain', 'RighttoComplaintext'],
    ['Contact', 'Contacttext']
  ];

  constructor(private translate: TranslateService, private userService: UserService) {
    translate.setDefaultLang('en');
  }

  ngOnInit() {
    const stored = localStorage.getItem('selectedLanguage');
    this.selectedLanguage = this.supportedLanguages.some(l => l.code === stored) ? stored as string : 'en';
    this.translate.use(this.selectedLanguage);
    this.loadDocument();
  }

  private loadDocument() {
    this.userService.getLegalDocument('privacy_policy', this.selectedLanguage).subscribe(
      doc => {
        this.documentHtml = doc.text ? (marked.parse(doc.text, { gfm: true }) as string) : '';
        this.version = doc.version;
      },
      () => (this.documentHtml = '')
    );
  }

  changeLanguage(lang: string) {
    this.selectedLanguage = lang;
    this.translate.use(lang);
    localStorage.setItem('selectedLanguage', lang);
    this.userService.loadLang.next(lang);
    this.loadDocument();
  }
}
